import { render, staticRenderFns } from "./SubDivisions.vue?vue&type=template&id=34eab586&scoped=true&"
import script from "./SubDivisions.vue?vue&type=script&lang=js&"
export * from "./SubDivisions.vue?vue&type=script&lang=js&"
import style0 from "./SubDivisions.vue?vue&type=style&index=0&id=34eab586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eab586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
